
import { collection } from 'firebase/firestore';
import { getAnalytics,isSupported } from "firebase/analytics";
import { firebaseHelper } from 'ui';

const useEmulator =  window.location.hostname.includes('localhost') && import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true' || false
export const useStaging = !    (window.location.hostname.includes('mattoboard.com') || window.location.hostname.includes('preview'))
//export const useStaging=true

export const subscriptionURL = useStaging ? 
  'https://us-central1-mattoboard-staging.cloudfunctions.net/StripeProcessor5/getSubscriptionByID'
  : 'https://us-east1-mattoboard-b8284.cloudfunctions.net/StripeProcessor5/getSubscriptionByID';

const firebaseConfigProduction = {
  apiKey: "AIzaSyCTGdYrK9O7Vt2DpG3aqMi-9Kux3uKPEvA",
//authDomain: "mattoboard-b8284.firebaseapp.com",
  authDomain: "mattoboard.com",
  projectId: "mattoboard-b8284",
  storageBucket: "mattoboard-b8284.appspot.com",
  messagingSenderId: "709632310154",
  appId: "1:709632310154:web:ceeb0aa750d8c2d3e12673",
  measurementId: "G-0SZ3V9684H"
};
const firebaseConfigStaging = {
	apiKey: "AIzaSyAt-1lkI-PZaYeP4uQvLhYCJbWRU1DpzZU",
	// authDomain: "mattoboard-staging.firebaseapp.com",
	authDomain: "mattoboard-staging.web.app",
	projectId: "mattoboard-staging",
	storageBucket: "mattoboard-staging.appspot.com",
	messagingSenderId: "829457126264",
	appId: "1:829457126264:web:4593809c2b4fa145a46e8d",
	//measurementId: "${config.measurementId}"
};

const firebaseConfigEmulator = {
	apiKey: 'fake-api-key',
	authDomain: 'localhost',
	projectId: 'demo-project',
	appId: 'demo-app-id',
	analyticsId: 'demo-analytics-id',
	emulator:true
}


export let firebaseConfig = null
if (useEmulator) {
	firebaseConfig = firebaseConfigEmulator
}
else { firebaseConfig =  useStaging ? firebaseConfigStaging : firebaseConfigProduction  }





/*
Adapters to the now shared library 	in ui + some legacy variables.
*/
export let googleSignup   = firebaseHelper.googleSignup
export let sendResetPassword = firebaseHelper.sendResetPassword
export let resetPassword = firebaseHelper.resetPassword
export let getDocByID = firebaseHelper.getDocByID
export let getUrlFromRef  = firebaseHelper.URLFromRef
export let getPublicURL = firebaseHelper.publicURL
export let updateRecord = firebaseHelper.updateRecord
export let uploadAndSave = firebaseHelper.uploadAndSave
export let uploadAndSave2 = firebaseHelper.uploadAndSave2

export let deleteRecordAndFiles = firebaseHelper.deleteRecordAndFiles
export let uploadFileToGCloud = firebaseHelper.uploadFileToGCloud
export let getProductCache = firebaseHelper.getProductCache

//export const storageURL = useStaging ? 'mattoboard-staging.appspot.com' : 'mattoboard-b8284.appspot.com'

// //export const firebaseApp = initializeApp(useStaging ? firebaseConfigStaging : firebaseConfig)
export let firebaseApp=null
export let analytics = null
export let projectsDB = null
export let productsDB = null
export let profilesDB = null
export let userImagesDB = null
export let userFavoritesDB = null
export let userCollectionsDB = null
export let userProductsDB = null
export let userProductFiltersDB = null
export let userImageFiltersDB = null
export let suppliersDB = null
export let notificationsDB = null
export let notificationsViewedDB = null
export let storageURL=null
export let deepRenderDB = null
export let firebaseDB = null

export const setupHelpers = () => {
	firebaseApp = firebaseHelper.firebaseApp
	const db = firebaseHelper.db	
	firebaseDB = db

	isSupported().then((result) => {

		if (result && firebaseConfig.emulator != true) {
			analytics = getAnalytics(firebaseApp)
		}
	})

	projectsDB = collection(db, "projects")
	productsDB = collection(db, "productsV2")	
	profilesDB = collection(db, "profiles")
	userImagesDB = collection(db,"userImages")
	userProductsDB = collection(db,"userProducts")
	userProductFiltersDB = collection(db,"userProductFilters")
	userImageFiltersDB = collection(db,"userImageFilters")
	userFavoritesDB = collection(db,"userFavorites")
	userCollectionsDB = collection(db,"usersMyCollection")
	deepRenderDB = collection(db,"deepRender")
	suppliersDB = collection(db,"suppliers")
	notificationsDB = collection(db,"notifications")
	notificationsViewedDB = collection(db,"notifications_viewed")
	storageURL = firebaseApp.options.storageBucket
	googleSignup   = firebaseHelper.googleSignup.bind(firebaseHelper)
	sendResetPassword = firebaseHelper.sendResetPassword.bind(firebaseHelper)
	resetPassword = firebaseHelper.resetPassword.bind(firebaseHelper)
	getDocByID = firebaseHelper.getDocByID.bind(firebaseHelper)
	getUrlFromRef  = firebaseHelper.URLFromRef.bind(firebaseHelper)
	getPublicURL = firebaseHelper.publicURL.bind(firebaseHelper)
	updateRecord = firebaseHelper.updateRecord.bind(firebaseHelper)
	uploadAndSave = firebaseHelper.uploadAndSave.bind(firebaseHelper)
	uploadAndSave2 = firebaseHelper.uploadAndSave2.bind(firebaseHelper)
	deleteRecordAndFiles = firebaseHelper.deleteRecordAndFiles.bind(firebaseHelper)
	uploadFileToGCloud = firebaseHelper.uploadFileToGCloud.bind(firebaseHelper)
	getProductCache = firebaseHelper.getProductCache.bind(firebaseHelper)
}

